module.exports = __webpack_public_path__ + "static/media/bordir.c0d95b73.png";